<form [formGroup]="form">

    <div class="modal-header">
        <p class="modal-title"><strong>{{ title }}</strong></p>
       <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>
    <div class="modal-body">
        <div class="col-12">
            <fieldset class="field-container">
                <legend class="field-container-title">User</legend>

                <div class="row">
                    <div class="mb-3 col-md-4">
                        <label for="email">Name</label>
                        <input *ngIf="editMode" type="text" class="form-control form-control-sm" id="name"
                            formControlName="name" placeholder="Name">
                        <ng-select *ngIf="!editMode" [items]="options$ | async" bindLabel="displayName"
                            [minTermLength]="3" typeToSearchText="Please enter 3 or more characters"
                            [loading]="showLoader" (change)="onChange($event)" formControlName="aduser"
                            [placeholder]="'Employees'" [typeahead]="searchInput$">
                            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                <div><span>{{item.displayName}}</span></div>
                                <div><span><small>{{item.userPrincipalName}}</small></span></div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="mb-3 col-md-4">
                        <label for="email">Email address</label>
                        <input type="email" class="form-control form-control-sm" id="email" formControlName="email"
                            placeholder="name@ey.com">
                    </div>

                    <div class="mb-3 col-md-4">
                        <label for="roles">Delegate</label>
                        <ng-select [items]="delegateOpts$ | async" bindLabel="name" [minTermLength]="3"
                            typeToSearchText="Please enter 3 or more characters" [loading]="showLoader"
                            formControlName="delegate" bindValue="id" [placeholder]="'Employees'"
                            [typeahead]="searchInput$">
                            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                <div><span>{{item.name}}</span></div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="mb-3 col-md">
                        <label for="roles">Roles *</label>
                        <!-- <eos-multi-select-dropdown id="roles" class="form-control form-control-sm"
                            placeholder="Select role" [data]="roles$ | async" [settings]="roleddSettings"
                            formControlName="roles" required>
                        </eos-multi-select-dropdown> -->
                        <eos-multi-select-dropdown id="roles" class="form-control form-control-sm"
                            placeholder="Select role" [data]="roles$ | async" [settings]="roleddSettings"
                            formControlName="roles" required>

                        </eos-multi-select-dropdown>
                    </div>
                    <div class="mb-3 col-md">
                        <label for="roles">Active role *</label>
                        <ng-select [items]="userRoles$" bindLabel="displayName" [minTermLength]="3"
                            formControlName="activeRole" [placeholder]="'User roles'" required>
                            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                <div><span>{{item}}</span></div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="row">
                  <div class="mb-3 col-md-6">
                    <label for="locations">Location *</label>
                    <eos-multi-select-dropdown id="locations" (onSelect)="adjustValues()"
                                             (onDeSelect)="adjustValues()" class="form-control form-control-sm"
                                             placeholder="Select location" [data]="locations$ | async" [settings]="leddSettings"
                                             formControlName="locations" required>
                    </eos-multi-select-dropdown>
                    <span>
                      {{isDubaiSelected}}
                    </span>
                  </div>                 
                    <div class="mb-3 col-md-6">
                      <br>
                      <label>
                        <input formControlName="active" class="check-input mt-2" type="checkbox" />
                        Active Employee
                      </label>
                    </div>
                  </div>             
                  
        <!-- new fields for PJ Team START -->     
            <div class="row">
        
                <div class="mb-3 col-md-6">
                    <label for="empCategories">Employee Category (Applicable to Recruitment and PJ)</label>
                    <eos-multi-select-dropdown id="empCat" (onSelect)="adjustValues()" (onDeSelect)="adjustValues()"
                        class="form-control form-control-sm" placeholder="Select Employee category"
                        [data]="empCategory$ | async" [settings]="leddSettings" formControlName="empCategories">
                    </eos-multi-select-dropdown>
                </div>
                <div class="mb-3 col-md-6">
                    <label for="contractTypes">Contract type (Applicable to Recruitment and PJ)</label>
                    <eos-multi-select-dropdown id="contractTypes" (onSelect)="adjustValues()" (onDeSelect)="adjustValues()"
                        class="form-control form-control-sm" placeholder="Select contract type" [data]="contractTypes$ | async"
                        [settings]="leddSettings" formControlName="contractTypes">
                    </eos-multi-select-dropdown>
                </div>
            </div>
        <!-- new fields for PJ Team END -->
    </fieldset>

            <fieldset class="field-container">
                <legend class="field-container-title">For Immigration team members</legend>

                <div class="row">
                   
                    <div class="mb-3 col-md-6">
                        <label for="les">Legal entities</label>
                        <eos-multi-select-dropdown  id="les" (onSelect)="adjustValues()" (onDeSelect)="adjustValues()"
                            class="form-control form-control-sm" placeholder="Select entity" [data]="ole$ | async"
                            [settings]="leddSettings" formControlName="les">
                        </eos-multi-select-dropdown>
                    </div>

                </div>
            </fieldset>
        <!-- new fields for PJ Team START -->
        <!-- <fieldset class="field-container">
            <legend class="field-container-title">For PJ team members</legend>
        
            <div class="row">
        
                <div class="mb-3 col-md-6">
                    <label for="empCategories">Employee Category</label>
                    <eos-multi-select-dropdown id="empCat" (onSelect)="adjustValues()" (onDeSelect)="adjustValues()"
                        class="form-control form-control-sm" placeholder="Select Employee category"
                        [data]="empCategory$ | async" [settings]="leddSettings" formControlName="empCategories">
                    </eos-multi-select-dropdown>
                </div>
                <div class="mb-3 col-md-6">
                    <label for="contractTypes">Contract type</label>
                    <eos-multi-select-dropdown id="contractTypes" (onSelect)="adjustValues()" (onDeSelect)="adjustValues()"
                        class="form-control form-control-sm" placeholder="Select contract type" [data]="contractTypes$ | async"
                        [settings]="leddSettings" formControlName="contractTypes">
                    </eos-multi-select-dropdown>
                </div>
            </div>
        </fieldset> -->
        <!-- new fields for PJ Team END -->
            <fieldset class="field-container">
                <legend class="field-container-title">For Exit team members</legend>

                <div class="row">
                    <div class="mb-3 col-md-6">
                        <label for="locations">Exit locations</label>
                        <eos-multi-select-dropdown id="exitlocations" (onSelect)="adjustValues()"
                            (onDeSelect)="adjustValues()" class="form-control form-control-sm"
                            placeholder="Select location" [data]="locations$ | async" [settings]="leddSettings"
                            formControlName="exitLocations">
                        </eos-multi-select-dropdown>
                    </div>
                    <div class="mb-3 col-md-6">
                        <label for="locations">Exit service lines</label>
                        <eos-multi-select-dropdown id="exitSls" (onSelect)="adjustValues()" (onDeSelect)="adjustValues()"
                            class="form-control form-control-sm" placeholder="Select service lines" [data]="sl$ | async"
                            [settings]="leddSettings" formControlName="exitServiceLines">
                        </eos-multi-select-dropdown>
                    </div>
                </div>

            </fieldset>


            <div class="col-12 text-center mt-3">
                <button class="btn btn-secondary me-2" (click)="onCancel()"> Cancel </button>
                <button *ngIf="editMode" class="btn btn-primary me-2" (click)="onUpdate()"
                    [disabled]="form.invalid && notOnlyEmpAndAdmin">
                    Update </button>
                <button *ngIf="!editMode" class="btn btn-primary" (click)="onSave()" [disabled]="form.invalid  && notOnlyEmpAndAdmin"> Add
                </button>
            </div>
        </div>
    </div>
</form>
